import { AppSettings } from "@core/types";
import { activeModule } from "../../../providers/active-module";

const aboutCompanyHtml = `
  <h3>Доставка продуктов на дом в Грозном.</h3>
  Parhato.ru — это онлайн-магазин по доставке товаров на дом и в офис в Грозном.
  <br />
   В нашем интернет-магазине представлен широкий ассортимент продуктов питания и других товаров, начиная от детского питания и заканчивая бытовой химией. Заказ собирается на складе, где строго соблюдаются правила товарного соседства и контроль сроков годности. Для доставки продуктов используются соответствующие автомобили, способные обеспечить сохранность товара и необходимую температуру. Каждый товар проходит тщательный контроль качества.
   <br />
   Благодаря своевременной доставке, в том числе и в  день заказа или в день праздника, и коротким временным  интервалам получения, Parhato.ru обеспечивает высокий уровень сервиса. Купить свежие продукты питания с доставкой на дом в Грозном можно на сайте интернет-магазина, в мобильном приложении, с помощью <a href="tel:+79287375050">контактного центра</a> или<a href="https://parhato.ru/contacts/"> других видов связи,</a> представленных на сайте. Наш курьер доставит заказ до двери.
   <br />
   Наш онлайн-супермаркет всегда радует своих клиентов выгодными предложениями, <a href="https://app.parhato.ru/products/0/0/sale/">акциями</a>, новинками и доступными ценами.
   <br />
   Parhato.ru - удобство и качество!
  `;

let Config: AppSettings = {
  appUrl: "https://app.parhato.ru",
  exitAppICantGoBack: true,
  isOffertaPageEnabled: false,
  haveTabs: true,
  baseUrl: process.env.REACT_APP_PARHATO_URL || "https://proxy.parhato.ru",
  CDNDomain: "cdn.parhato.ru",
  sharedData: {
    title: "Parhato",
    text: `Parhato - это ваш личный помощник по доставке продуктов и других различных товаров, начиная от детского питания и заканчивая бытовой химией.\n\n`,
    androidUrl: "https://play.google.com/store/apps/details?id=ru.parhato.app",
    iosUrl: "https://apps.apple.com/ru/app/parhato/id1572201263",
  },

  minimumOrderAmount: 0,
  shouldCheckItemsAvailability: false,
  showProductReviews: true,
  showCouponsInCart: true,

  isBonusPointsEnabled: true,
  isDeliveryDateEnabled: true,
  orderHistoryPagination: true,
  isCustomerAdressesEnabled: true,
  isReferralEnabled: true,

  signUpPage: {
    nameFieldEnabled: false,
    lastNameFieldEnabled: false,
  },

  deleteAccountLink: "https://proxy.fortime.staq.dev/delete-me.html",
  showSendCustomerRequestButton: true,
  cardProduct: false,
  updateUserForm: {
    isUpdatePasswordEnabled: true,
    showPhoneNumberInput: true,
  },
  isOnlinePaymentEnabled: false,
  privacyPolicyPageLink: "https://parhato.ru/privacy/",
  isSeoOnHomePageEnabled: true,
  companyPhoneNumber: "+7 (928) 737-50-50",
  isContentInFooterShown: true,
  hasCardLoyalty: false,
  showSliderCatalogButton: false,
  addressSettings: {
    showCustomerAddresses: true,
    showFlatDelivery: true,
    addressInputDependsOnShippingMethod: false,
  },
  homePageCategories: {
    customersChoice: { title: "Customers Choice", isEnabled: true },
    featured: { title: "Featured Products", isEnabled: true },
    sale: { title: "On Sale Products", isEnabled: true },
    latest: { title: "Latest Addest", isEnabled: true },
  },
  expressMaxWeightKg: 30,
  isExpressDeliveryEnabled: false,
  showNewVersionAlert: true,
  wishListIcons: true,
  showOrderPageProductCardCounter: false,
  cartMinAmountFromMethods: true,
  siteDomain: "parhato.ru",

  loginPage: {
    phoneOrEmailFieldEnabled: true,
  },
  orderDetailPage: {
    reviewOrderEnabled: true,
    repeatOrderEnabled: true,
  },
  newProductDuration: 20,
  homeSliderAutoplaySeconds: 10,
  image: {
    isDownSizeEnabled: true,
    isLazyLoadingEnabled: true,
    base64Extension: "jpeg",
    isNeedBase65Prefix: true,
    isBase64InSrc: true,
  },
  showStockQuantity: false,
  lowStockThresholdToShowPercent: 10,
  minLowStockThresholdToShowNumber: 10,
  appIosId: "1572201263",
  search: {
    minSearchLength: 3,
    inputDebounceTimeMs: 500,
  },
  usePriceHTML: true,
  headquarters: [43.315434, 45.68801],
  isNecessaryToCreateAddress: true,
  contacts: [],
  requisites: [],
  aboutCompanyHtml: aboutCompanyHtml,
  defineSiteActivity: "это доставка продуктов питания, бытовой химии и текстиля.",
  isUnavailableProductsEnabled: true,
  customerSurvey: {
    isEnabled: false,
    allowDismiss: true,
  },
  shipping: {
    showCurrentShippingAddressSelect: true,
    showDefaultShippingZone: true,
    showOldAddressInputOnShippingPage: true,
    isShippingZonesEnabled: true,
  },
  isStoriesEnabled: true,
  isInviteEnabled: false,
  hasClientToDeleteUser: false,
  isCardsEnabled: false,
  pages: {
    authPageName: "common",
    homePageName: "common",
    cartPageName: "common",
    myOrdersPageName: "common",
    myAccountPageName: "common",
    searchMainCategoriesPageName: "common",
    thankYouPageName: "common",
    subCategoriesPageName: "common",
    orderDetailPageName: "common",
    wishlistPageName: "common",
    productDetailPageName: "common",
  },
  isPaymentsEnabled: true,
  isSettingsPageEnabled: false,
  isEmailPushEnabled: false,
  isCartProgressButtonEnabled: false,
  isCartQuantityInputEnabled: false,
  isWeightProductQuantityStepEnabled: false,
  showUnavailableProductsModal: true,
  isImageInCartStoreEnabled: true,
  isShouldRecalculatePriceOnReplace: false,
  isToggleSwitchModuleEnabled: false,
  moduleOnInit: "PARHATO2",
  maxWeightForOrderKG: 30,
  isCartSyncEnabled: true,
  showStockStatus: false,
  shareProduct: false,
  isReferralStatsEnabled: false,
  isAdditionalPageEnabled: true,
  showParentName: false,
  isDeliveryIntervalEnabled: true,
  isLocalNotificationsEnabled: true,
  isFCMNotificationsEnabled: true,
  staticOrderDataEnabled: false,
  expressAllowedTimeStart: "10:00",
  expressAllowedTimeEnd: "23:59",
  maxWeightFeeStep: 10,
  isProductSubscriptionsEnabled: false,
  maxWeightForFeeKG: 30,
  extraWeightFee: 50,
  isWeightFeeEnabled: false,
  defaultShippingZoneId: "1",
  forceToGoNewVersion: true,
  isOrderChatEnabled: true,
  stepForWeightProductQuantity: 1,
};

// Core specific values, so they are not implicitly inherited by other modules
if (activeModule === "CORE") {
  Config = {
    ...Config,
    appMetrica: {
      enabled: true,
      apiKey: process.env.REACT_APP_PARHATO_APPMETRICA_API_KEY!,
    },
  };
}

export { Config };
